import { Box, Typography, Button, Paper, ButtonGroup } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CelebrationIcon from "@mui/icons-material/Celebration";
import { LotterySessionDto } from "../../models/Lottery";
import { useState } from "react";

interface IRunLotteryDrawAnimationProps {
  selectedLottery: LotterySessionDto;
  runDraw: any;
  setAnimationEnded?: any;
}

export const RunLotteryDrawAnimation = ({
  selectedLottery,
  runDraw,
  setAnimationEnded,
}: IRunLotteryDrawAnimationProps) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [currentWinner, setCurrentWinner] = useState<any>(null);

  const runMockDraw = async () => {
    if (!selectedLottery) return;
    setAnimationEnded(false);
    await runDraw(selectedLottery.sessionId, 25);
    setIsSpinning(true);
    setCurrentWinner(null);

    const lotteryPrizes: any = [
      "Κούπα ή Θερμός",
      "Voucher για Μασάζ (ή ηλεκτρικό μασάζ χειρός)",
      "Σετ Κεριών & Αρωματικών Χώρου",
      "Κουτί με Ποιοτικές Σοκολάτες ή Χειροποίητα Γλυκά",
      "Βιβλίο ή Voucher Βιβλιοπωλείου",
      "Κάρτα Δώρου για Καφέ",
      "Σετ Προϊόντων Περιποίησης (π.χ. κρέμες χεριών, μάσκες προσώπου)",
      "Χνουδωτές Κάλτσες ή Σετ Σκούφου/Γαντιών",
      "Power Bank ή Ασύρματος Φορτιστής",
      "Μπουκάλι Κρασί, Λικέρ ή Craft Μπύρες",
      "Ημερολόγιο/Ατζέντα για το Νέο Έτος",
      "Μικρό Επιτραπέζιο Παιχνίδι ή Παζλ",
      "Σετ με Εκλεκτές Ποικιλίες Τσαγιού/Καφέ",
      "Συλλεκτικό Χριστουγεννιάτικο Στολίδι",
      "Μικρό Φυτό Εσωτερικού Χώρου (π.χ. Αλεξανδρινό)",
      "Χνουδωτό Ριχτάρι ή Κουβέρτα Καναπέ",
      "Κομψή Κορνίζα ή Μικρό Άλμπουμ Φωτογραφιών",
      "Εισιτήρια για Κινηματογράφο/Θέατρο",
      "Εργαλεία Κουζίνας (π.χ. Ανοιχτήρι Κρασιού, Ξύλινες Κουτάλες)",
      "Μάσκα Ύπνου & Άλατα Μπάνιου",
      "Κούπα ή Θερμός",
      "Voucher για Μασάζ (ή ηλεκτρικό μασάζ χειρός)",
      "Σετ Κεριών & Αρωματικών Χώρου",
      "Κουτί με Ποιοτικές Σοκολάτες ή Χειροποίητα Γλυκά",
      "Βιβλίο ή Voucher Βιβλιοπωλείου",
    ];

    // Animate through random names
    let animationCount = 0;
    const maxAnimations = 20;
    const animationInterval = setInterval(() => {
      const randomParticipant = lotteryPrizes[Math.floor(Math.random() * 20)];
      const randomPrize =
        lotteryPrizes[Math.floor(Math.random() * 10)] || "Prize";
      setCurrentWinner({
        winningNumber: randomParticipant,
        prize: randomPrize,
      });
      animationCount++;

      if (animationCount >= maxAnimations) {
        clearInterval(animationInterval);
        setIsSpinning(false);
        setCurrentWinner(null);
        setAnimationEnded(true);
      }
    }, 100);
  };

  return (
    <Paper
      sx={{
        p: 4,
        borderRadius: 4,
        mb: 4,
      }}
    >
      {isSpinning && currentWinner && (
        <Box
          sx={{
            textAlign: "center",
            py: 4,
            mb: 3,
            bgcolor: "hsl(350, 80%, 40%)",
            borderRadius: 3,
            color: "white",
          }}
        >
          <Box className="animate-float">
            <CelebrationIcon sx={{ fontSize: 48, mb: 2 }} />
          </Box>
          <Typography variant="h5" sx={{ opacity: 0.9 }}>
            🎁 {currentWinner.prize}
          </Typography>
        </Box>
      )}

      <Box sx={{ textAlign: "center" }}>
        <ButtonGroup
          variant="contained"
          aria-label="Button group with a nested menu"
        ></ButtonGroup>
        <Button
          variant="contained"
          size="large"
          onClick={runMockDraw}
          disabled={
            !selectedLottery ||
            isSpinning ||
            selectedLottery?.totalPrizes === 0 ||
            selectedLottery?.totalPrizes === selectedLottery?.drawnPrizesCount
          }
          startIcon={
            isSpinning ? (
              <CelebrationIcon className="animate-spin-wheel" />
            ) : (
              <PlayCircleIcon />
            )
          }
          sx={{
            background: isSpinning
              ? "hsl(45, 90%, 50%)"
              : "linear-gradient(135deg, hsl(350, 80%, 40%) 0%, hsl(350, 85%, 30%) 100%)",
            color: isSpinning ? "hsl(45, 90%, 15%)" : "white",
            fontWeight: 700,
            px: 6,
            py: 2,
            fontSize: "1.2rem",
            borderRadius: 3,
            "&:hover": {
              background:
                "linear-gradient(135deg, hsl(350, 75%, 45%) 0%, hsl(350, 80%, 35%) 100%)",
            },
            "&.Mui-disabled": {
              background: "hsl(30, 20%, 85%)",
              color: "hsl(30, 20%, 55%)",
            },
          }}
        >
          {isSpinning ? "Κληρώνει..." : "Κληρωση!"}
        </Button>
        <ButtonGroup />
        {selectedLottery?.totalPrizes === 0 && (
          <Typography sx={{ mt: 2, color: "hsl(0, 60%, 50%)" }}>
            Πρόσθεσε έπαθλα σε αυτήν τη λοταρία πρώτα!
          </Typography>
        )}
      </Box>
    </Paper>
  );
};
